<template>
  <div class="agent">
    <!-- <div class="agentManage">首页/代理商管理</div> -->
    <!-- 弹框 -->
    <div class="addInfo">
      <span class="infoName">代理商管理</span>
      <div class="addBtn">
        <el-button type="primary" @click="addAgent" round>+ 新增</el-button>
        <el-dialog title="新增代理商" :visible.sync="dialogFormVisible1" :before-close="handleClose" v-if="dialogFormVisible1" :close-on-click-modal="false">
          <!-- 弹出框表单 -->
          <el-form :model="AgentForm" ref="subAgentForm" :rules="ruleValidate" :label-width="formLabelWidth">
            <!-- 多选框 -->
            <el-form-item
              label="云管理:"
              prop="checkedClouds"
            >
              <el-checkbox-group type="checkbox" true-label v-model="checkedClouds" @change="changeClouds">
                <el-checkbox v-for="item in clouds" :label="item.id" :key="item.id">{{item.cloudName}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="代理商名称:" prop="companyName">
              <el-input v-model="AgentForm.companyName"  autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="contactName">
              <el-input v-model="AgentForm.contactName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="电话:" prop="mobile">
              <el-input v-model="AgentForm.mobile" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="代理商地址:" prop="address">
              <el-input v-model="AgentForm.address" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="Logo:">
              <!-- action上传图片的接口 -->
              <!-- name字段名字是传递后端的参数 -->
              <el-upload
                class="avatar-uploader"
                ref="upload"
                :action="action"
                :show-file-list="false"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :on-remove="removeAvatar"
                :before-upload="beforeAvatarUpload"
                name="file"
                :multiple="false"
                :limit="1"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="cancelClick">取 消</el-button>
            <!-- <el-button type="primary" @click="confirmClick('subAgentForm')" class="submit"  :disabled="isDisabled">确 定</el-button> -->
            <el-button type="primary" @click="confirmClick('subAgentForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableInfo">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="{color: '#333'}"
      element-loading-background = "rgba(255, 255, 255, .5)" element-loading-text = "加载中，请稍后..." element-loading-spinner = "el-icon-loading">
        <el-table-column prop="companyName" label="代理商名称" min-width="120">
        </el-table-column>
        <el-table-column prop="contactName" label="联系人" min-width="80">
        </el-table-column>
        <el-table-column prop="mobile" label="电话" min-width="120"> </el-table-column>
        <el-table-column prop="logoUrl" label="logo" min-width="100">
          <template slot-scope="scope">
            <img :src="scope.row.logoUrl" alt="" width="50" />
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="{row}">
            <!-- row展示每一行的表格数据信息 --> 
            <el-button @click="editAgent(row)" type="text" size="small" class="edit" v-if="row.companyName=='普杰物联'" disabled>修改</el-button>
            <el-button @click="editAgent(row)" type="text" size="small" class="edit" v-else>修改</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button type="text" size="small" class="delete" @click="delAgent(row)" v-if="row.companyName=='普杰物联'" disabled>删除</el-button>
            <el-button type="text" size="small" class="delete" @click="delAgent(row)" v-else>删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 编辑弹窗 -->
      <el-dialog title="修改代理商" :visible.sync="dialogFormVisible2" v-if="dialogFormVisible2" :close-on-click-modal="false">
        <el-form :model="AgentForm" ref="subAgentForm" :rules="ruleValidate" :label-width="formLabelWidth">
          <!-- 多选框 -->
          <el-form-item label="云管理:"      prop="checkedClouds">
            <el-checkbox-group type="checkbox" true-label v-model="checkedClouds" @change="changeClouds">
              <el-checkbox v-for="item in clouds" :label="item.id" :key="item.id">{{item.cloudName}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="代理商名称：" prop="companyName">
            <el-input v-model="AgentForm.companyName" autocomplete="off"></el-input>
          </el-form-item>
          <!-- <el-form-item label="公司地址：">
            <el-input v-model="AgentForm.address" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item label="联系人：" prop="contactName">
            <el-input v-model="AgentForm.contactName" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="电话：" prop="mobile">
            <el-input v-model="AgentForm.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="logo：" prop="logo">
            <el-upload
              class="avatar-uploader"
              ref="upload"
              :action= 'action'
              :show-file-list="false"
              list-type="picture-card"
              :on-success="handleAvatarSuccess"
              :on-remove="removeAvatar"
              :before-upload="beforeAvatarUpload"
              name="file"
              :multiple="false"
              :limit="1"
              :file-list="fileList">
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelClick">取 消</el-button>
          <!-- <el-button type="primary" @click="confirmClick('subAgentForm')" class="submit" :disabled="isDisabled">确 定</el-button> -->
          <el-button type="primary" @click="confirmClick('subAgentForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="page.pageNum"
        :page-sizes="page_size_list"
        :page-size="page.pageSize"
        layout="prev, pager, next, sizes, total, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>

//引入代理商接口
import { agentInfo } from "@/api";
import {
  addAgentInfo,
  delAgentInfo,
  editAgentInfo,
  cloudCheckbox,
} from "@/api";
const api = require("@/api");
console.log(api);
export default {
  data() {
    //验证手机号
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => { 
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    };
    return {
      loading: false,
      loadingsubmit: false,
      confirmText: '确定',
      action: '',
      apiName: "",
      successMsg: "",
      warnMsg: "",
      errorMsg: "",
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      checkedClouds: [], //选中的id
      AgentForm: {
        address: "",
        companyName: "",
        contactName: "",
        mobile: "",
        logo: "",
        checkedClouds: []
      },
      ruleValidate: {
        companyName: [
          {required: true,message: "请输入代理商名称",trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("请输入正确的代理商名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        address: [
          {required: true,message: "请输入地址",trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("请输入正确的地址"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contactName: [
          {required: true,message: "请输入联系人",trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("请输入正确的联系人姓名"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        mobile: [
          {required: true,validator: checkPhone,trigger: "blur",},
        ],
      },
      formLabelWidth: "120px",
      //table
      tableData: [],
      //分页参数
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      page_size_list: [10,20,30],
      //新增logo
      imageUrl: "",
      fileList: [],//文件列表
      //多选框
      clouds: [],
    };
  },
  methods: {
    //table
    //渲染表格数据
    updateAgentTable(pageList) {
      //分页
      let page = pageList
      this.loading = true
      //调用列表接口
      agentInfo("", "", "", page).then((res) => {
        console.log("表格数据",res,);
        if (res.data.code == "0") {
          this.tableData = res.data.data;
          this.total = res.data.count;
        } 
        else {
          this.$message.warning("数据获取失败");
        }
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        console.log(err);
        this.$message.error("获取数据出错或网络错误");
      });
    },

    //新增logo
    //上传logo成功
    handleAvatarSuccess(res, file, fileList) {
      // console.log(fileList);//fileList是数组对象，包含file对象
      //清空已上传的文件列表
      this.$refs.upload.clearFiles();
      //图片上传成功，得到图片地址后再返回给后端图片地址
      this.AgentForm.logo = res.data.filePath;//本地图片路径
      //后台返回filePath: "company/logo/421a8f2f54b745e0911cabb2455efe77.png"
      this.imageUrl = URL.createObjectURL(file.raw);
      // console.log(this.imageUrl);//blob:http://localhost:8080/1f6e23ca-63a7-4d58-bfc6-f60fd3ef29ef
      this.$refs.upload.clearFiles()
    },

    //上传logo之前
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      return isJPG && isLt2M;
    },

    //删除logo
    removeAvatar() {
      //移除时地址变为空
      this.AgentForm.logo = "";
    },

    //dailog对话框
    //确定按钮
    confirmClick(formName) {
      this.loadingsubmit = true
      this.confirmText = "提交中..."
      this.AgentForm.checkedClouds = this.checkedClouds
      //数组转字符串
      // console.log(this.AgentForm.checkedClouds.toString());
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          //本地表单校验通过，将表单信息提交到后台
          console.log(this.AgentForm);
          //调用增加信息接口
          api[this.apiName](this.AgentForm)
            .then((res) => {
              if (res.data.code == '0') {
                //关闭dailog
                this.dialogFormVisible1 = false;
                this.dialogFormVisible2 = false;
                //提示添加成功，更新表格数据
                this.$message.success(this.successMsg);
                this.updateAgentTable(this.page);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(this.errorMsg);
            })
            .finally(()=>{
              this.loadingsubmit = false
              this.confirmText = "确定"
              loading.close();
            })
        } else {
          this.$message.error("表单校验不通过");
          this.loadingsubmit = false
          this.confirmText = "确定"
        }
      });
    },

    //对话框取消按钮
    cancelClick(){
      //清除表单数据
      Object.keys(this.AgentForm).forEach((key) => (this.AgentForm[key] = ""));
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },

    handleClose(){
      //清除表单数据
      Object.keys(this.AgentForm).forEach((key) => (this.AgentForm[key] = ""));
      this.dialogFormVisible1 = false;
      this.dialogFormVisible2 = false;
    },

    //删除代理商信息
    delAgent(row) {
      //删除的一整行表格数据
      if (row && row.id) {
        //提示信息是否永久删除
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //调用删除请求
          delAgentInfo(row.id)
          .then((res) => {
            if (res.data.code == '0') {
              this.$message.success("删除成功");
              //更新表格
              this.updateAgentTable(this.page);
            } 
            else {
              this.$message.warning(res.data.message);
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message.error("删除出错");
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });  
      }else{
        this.$message.error("没有row数据")
        return
      }
    },

    //修改代理商
    editAgent(row) {
      //弹出dailog
      this.dialogFormVisible2 = true;
      this.imageUrl = row.logoUrl
      //空值
      //数据回显
      if(row.cloudConfigId.charAt(row.cloudConfigId.length - 1)=== ','){
        row.cloudConfigId = row.cloudConfigId.substring(0,row.cloudConfigId.length-1);
      }
      this.AgentForm = { ...row };
      this.AgentForm.logo = row.logo
      // console.log(row.cloudConfigId);
      // 将字符串转换成数组，绑定到checkbox控件的v-model属性上
      this.checkedClouds = row.cloudConfigId.split(',').map(Number)
      //更改提交
      this.apiName = "editAgentInfo";
      this.successMsg = "修改成功";
      this.errorMsg = "修改数据不正确或网络异常";
      this.warnMsg = "修改失败"
      this.$refs['subAgentForm'].clearValidate(); // 仅清除验证
    },

    //增加信息
    addAgent() {
      //清空表单数据
      this.AgentForm = {}
      //清除图片
      this.imageUrl = "";
      this.fileList = []
      this.AgentForm.checkedClouds = []
      this.checkedClouds = []
      this.dialogFormVisible1 = true;
      this.apiName = "addAgentInfo";
      this.successMsg = "添加成功";
      this.warnMsg = "添加失败";
      this.errorMsg = "添加数据不正确或网络异常";
      if(this.$refs['subAgentForm'] !== undefined){
        this.$refs['subAgentForm'].resetFields();
      }
    },

    //改变分页
    changePage(page) {
      this.page.pageNum = page;
      this.updateAgentTable(this.page);
    },
    changeSize(val) {
      this.page.pageSize = val;
      this.updateAgentTable(this.page);
    },
    //多选框
    changeClouds(value) {
      this.AgentForm.checkedClouds = this.checkedClouds
    },

    //渲染多选框数据
    updateCheckbox() {
      cloudCheckbox().then((res) => {
        this.clouds = res.data.data;
      });
    },
  },
  mounted() {
    //渲染表格数据
    this.updateAgentTable(this.page);
    //渲染多选框数据
    this.updateCheckbox();
    //上传图片地址
    //process.env.NODE_ENV === "development" ? "http://192.168.23.41:8888/company/uploadLogo" : "https://config.pujie88.com/api/company/uploadLogo"
    this.action = process.env.NODE_ENV === "development" ? "https://config.pujie88.com/api/v2/company/uploadLogo" : "https://config.pujie88.com/api/v2/company/uploadLogo"
    // process.env.NODE_ENV+"/company/uploadLogo"
    // "http://192.168.23.41:8888/company/uploadLogo"
  },
};
</script>

<style scoped>
.agent {
  width: 100%;
  height: 100%;
  font-family: PingFang SC;
}

.addInfo{
  width: 100%;
  height: 80px;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 18px;
}
.addBtn .el-button.is-round{
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #455AF7;
  border-radius: 5px;
}

/* 上传logo */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.avatar {
  width: 146px;
  height: 146px;
  display: block;
}
/* 多选框 */
.checkboxes {
  display: flex;
  margin-bottom: 15px;
}
.cloudManage {
  width: 20%;
  padding: 0;
  margin-left: 35px;
}
.el-button--small, .el-button--small.is-round{
    padding: 3px 3px;
}

.tableInfo{
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  background: #fff;
}
.tableInfo >>> .el-table td,
.tableInfo >>> .el-table th {
  text-align: center !important;
}
.tableInfo >>> th{
  background: #F2F3F7;
}

/* 上传logo边框未设置 */
/* 弹出增加框 */
/* 弹出框 */
.agent >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.agent >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 549;
  background: #fff;
  
}
.agent >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.submit{
  background: #455AF7;
  border-color: #455AF7;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.agent >>> .el-dialog__footer{
  padding: 0 15px 15px 15px!important;
  
}
.el-form-item{
  width: 85%;
}
.agent >>> .el-select{
  width: 100%;
}
.agent >>> .el-form-item__content{
  margin-left: 100px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}

/* 分页 */
.pagination {
  width: 100%;
  height: 80px;
  background: #fff;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  box-sizing: border-box;
}
.pagination >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
.edit{
  color: #455AF7!important;
}
.delete{
  color: #FB3F4E!important;
}
/* logo */
</style>


// WEBPACK FOOTER //
// src/pages/Home/agentManagement/index.vue